import React from 'react'
import {Box, Spinner } from '@chakra-ui/react'

export const Loader = () => {
    return (        
        <Box 
            display="flex" 
            flex="1"
            h="100%" 
            position="absolute"
            left="0"
            top="0"
            w="100%"
            
            alignItems="center" 
            justifyContent="center" 
            // bg="gray.900" 
            // bgImage='./assets/auth-bg.svg' 
            // bgSize="cover" 
            // bgAttachment="fixed"
            >
            <Spinner
                thickness="3px"
                speed="0.65s"
                emptyColor="gray.300"
                color="brand.500"
                size="lg"
            />
        </Box>
    )
    
}